/**
 * Marketing campaign switch for international tournament focus on footypicks.co.uk.
 *
 * When true, HomePage shows World Cup / tournament flagship nav, hero pill,
 * competition-type emphasis, and organiser CTAs.
 * When false (default post-WC), marketing emphasises Predictor + Last Man Standing.
 *
 * Product routes (`/worldcup`, org WC comps), `app_config.public_worldcup`, and
 * the holding-page kill switch remain available regardless of this flag.
 *
 * Flip to `true` and redeploy for Euros / future World Cups.
 */
export const SHOW_TOURNAMENT_CAMPAIGN = false;
